import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FileService} from '../shared/services/fileService/file.service';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {LocalStorageService} from '../shared/services/localStorageService/local-storage.service';
import {DatePipe} from '@angular/common';
import {EmailService} from '../shared/services/emailService/email.service';
import {MatDialog, MatSnackBar} from '@angular/material';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {Race} from '../shared/classes/Race';
import {Category} from '../shared/classes/Category';
import {Racer} from '../racer-tab/Racer';
import {faUpload} from '@fortawesome/free-solid-svg-icons';
import {ChipItem} from '../shared/classes/ChipItem';
import {EditService} from '../shared/services/editService/edit.service';
import {duration} from 'moment';
import {TranslatePipe} from '../translate.pipe';

@Component({
  selector: 'app-start-number',
  templateUrl: './start-number.component.html',
  styleUrls: ['./start-number.component.css'],
  providers: [TranslatePipe]
})
export class StartNumberComponent implements OnInit {

  @ViewChild('fileInputButton', {static: false})
  fileInputButton;

  file: File | null = null;
  fileName = '';

  emptyForm = this.formBuilder.group({});
  isNew = false;
  plusButton = false;
  editButton = true;
  createTooltip = 'raceDetailPage.startNumberTab.tooltip.save';
  deleteTooltip = 'raceDetailPage.startNumberTab.tooltip.delete';
  addTooltip = 'raceDetailPage.startNumberTab.tooltip.save';

  numberForms = {};
  faUpload = faUpload;
  id;
  categories: Category[] = [];
  categoryAll: Category = { name: 'all', ageFrom: 0, ageTo: 99, available: false, short: 'all' };
  racers: Racer[] | any = undefined;
  filterefRacer = undefined;
  activeFilter = undefined;
  startNum: number[] = [];
  header = [
    {
      defName: 'name',
      translation: 'racesPage.racers.tabs.name',
      elem: 'name'
    },
    {
      defName: 'surname',
      translation: 'racesPage.racers.tabs.surname',
      elem: 'surname'
    },
    {
      defName: 'category',
      translation: 'racesPage.racers.tabs.category',
      elem: 'category'
    }
  ];
  displayedColumns: string[] = ['name', 'surname', 'category', 'startNum'];

  constructor(private formsService: FormsService,
              private activatedRoute: ActivatedRoute,
              private fileService: FileService,
              private editService: EditService,
              private snackBar: MatSnackBar,
              private translatePipe: TranslatePipe,
              private racesService: RacesService,
              private emailTableService: EmailTableService,
              private racerService: RacerService,
              private router: Router,
              private localStorageService: LocalStorageService,
              private datePipe: DatePipe,
              private emailService: EmailService,
              public dialog: MatDialog,
              private fioService: FioService,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.loadRacersByRace();
    this.categories = [];

    if (this.racesService.race === undefined) {
      this.racesService.getOne(this.id).then(data => {
        this.racesService.race = new Race();
        this.racesService.raceId = data.id;
        this.racesService.race = data.data();
        this.categories = this.racesService.race.categories;
        this.categories =  this.categories.filter(i => i !== this.categoryAll);
        this.categories.push(this.categoryAll);
      });
    } else {
      this.categories = this.racesService.race.categories;
      this.categories =  this.categories.filter(i => i !== this.categoryAll);
      this.categories.push(this.categoryAll);
    }
  }

  toArray(data) {
    const arr = [];
    data.forEach(item => {
      const racer = item.data();
      racer.id = item.id;
      arr.push(racer);
    });
    return arr;
  }

  filterRace(catName = this.categoryAll.name) {
    this.activeFilter = catName;
    if (catName === this.categoryAll.name) {
      this.filterefRacer = this.racers;
    } else {
      this.filterefRacer =  this.racers.filter(r => r.category === catName);
    }
  }

  getDefName(head): string {
    return head.defName;
  }

  loadRacersByRace() {
    this.racerService.getRacers().then(data => {
      this.racers = this.toArray(data).filter(i => i.raceId === this.racesService.raceId);
      this.filterRace(this.categoryAll.name);
      this.createStartNumberForms();
    });
  }

  createStartNumberForms() {
    this.racers.forEach(r => {
      this.numberForms[r.id] = this.formBuilder.group({
        startNum: [r.startNumber, []],
        chipNum: ['', []]
      });
    });
  }

  fileInput() {
    this.fileInputButton.nativeElement.click();
  }

  loadFile() {
    const files: {[key: string]: File} = this.fileInputButton.nativeElement.files;

    this.fileService.loadFileAsText(files).onload = () => {
      this.fileName = this.fileService.name;
      const csv: string = this.fileService.reader.result as string;
      this.exportXML(csv);
    };
  }

  isEdit() {
    return this.editService.editable;
  }

  selectChip(chips: ChipItem[], startNum): ChipItem[] {
    if ( !startNum ) {
      const c: ChipItem[] = [];
      c.push(chips[0]);
      for (let i = 1; i < chips.length; i++) {
        if (chips[i].startNum === c[0].startNum) {
          c.push(chips[i]);
          break;
        }
      }
      return c;
    }
    return chips.filter(c => Number(c.startNum) === Number(startNum));
  }

  exportXML(csv: string) {
    let chipes: ChipItem[] = this.parseFile(csv);
    let usedChipes: ChipItem[] = [];
    let xmlString: string = '';
    let i = 1;
    let chipId = 0;
    xmlString = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n`;
    xmlString = `${xmlString}<root xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">\n`;
    console.dir(this.racers.length);
    console.dir(chipes.length);
    this.racers.forEach(racer => {
      const startNum = this.numberForms[racer.id].get('startNum').value;
      let chip: ChipItem[] = this.selectChip(chipes, startNum);
      if(chip.length === 0) {
        chip = this.selectChip(usedChipes, startNum);
      }
      chip.forEach(c => {
        usedChipes.push(...chipes.filter(ch => ch !== c));
      });
      console.dir(chip[0]);
      console.log(startNum);

      const trackShort = this.racesService.race.track.filter(t => t.track === racer.track)[0].trackShort;

      xmlString = `${xmlString}\t<racer>\n`;
      xmlString = `${xmlString}\t\t<race>${trackShort}</race>\n`;
      xmlString = `${xmlString}\t\t<category>${racer.category}</category>\n`;
      xmlString = `${xmlString}\t\t<firstName>${racer.name}</firstName>\n`;
      xmlString = `${xmlString}\t\t<lastName>${racer.surname.toUpperCase()}</lastName>\n`;
      xmlString = `${xmlString}\t\t<startNumber>${chip[0].startNum}</startNumber>\n`;
      xmlString = `${xmlString}\t\t<chip1>${chip[0].id}</chip1>\n`;
      if (chip.length === 2) {
        xmlString = `${xmlString}\t\t<chip2>${chip[1].id}</chip2>\n`;
      }
      xmlString = `${xmlString}\t\t<birthYear>${racer.year}</birthYear>\n`;
      xmlString = `${xmlString}\t\t<gender>${racer.sex.toLowerCase() === 'muž' ? 'M' : 'F'}</gender>\n`;
      xmlString = `${xmlString}\t\t<club>${racer.club}</club>\n`;
      xmlString = `${xmlString}\t\t<state>CZ</state>\n`;
      xmlString = `${xmlString}\t\t<racingStatus>REG</racingStatus>\n`;
      xmlString = `${xmlString}\t\t<orderIndex>${i}</orderIndex>\n`;
      xmlString = `${xmlString}\t\t<phone>${racer.mobile}</phone>\n`;
      xmlString = `${xmlString}\t\t<email>${racer.email}</email>\n`;
      xmlString = `${xmlString}\t\t<poznamka>${racer.note}</poznamka>\n`;
      xmlString = `${xmlString}\t\t<poznamka2>${racer.note}</poznamka2>\n`;
      xmlString = `${xmlString}\t</racer>\n`;
      i++;
      chipId++;
    });
    xmlString = `${xmlString}</root>`;
    this.fileService.downloadFile(xmlString);
  }

  parseFile(csv: string): ChipItem[] {
    const chips: ChipItem[] = [];
    const lines: string[] = csv.split('\n');

    for(let lineIndex = 1; lineIndex < lines.length; lineIndex++) {
      const chipItem: ChipItem = new ChipItem();
      const parsed: string[] = lines[lineIndex].split(';');
      chipItem.id = parsed[0];
      chipItem.startNum = parsed[1];
      chips.push(chipItem);
    }
    return chips;
  }

  save(item) {
    this.racers.forEach(racer => {
      let num = this.numberForms[racer.id].get('startNum').value;
      if (!num) {
        num = '';
      }
      racer.startNumber = num;
      this.racerService.update(racer).then(() => {
        this.loadRacersByRace();
        this.openSnack(this.translatePipe.transform('raceDetailPage.startNumberTab.snack.success'),  this.translatePipe.transform('raceDetailPage.startNumberTab.snack.action')  , 5000);
      });
    });
  }

  private openSnack(message, action, time) {
    const snack = this.snackBar.open(message, action, {
      duration: time,
    });
    snack.onAction().subscribe(() => {
    });
  }

  add(item) {

  }

  delete(item) {
    this.racers.forEach((r) => {
      r.startNumber = '';
      this.racerService.update(r).then(() => {
        this.loadRacersByRace();
        this.openSnack(this.translatePipe.transform('raceDetailPage.startNumberTab.snack.delete'),  this.translatePipe.transform('raceDetailPage.startNumberTab.snack.action')  , 5000);
      });
    });
  }

}
